//const casl = require('casl')
import { AbilityBuilder } from "casl";
import constants from "../constants";

function subjectName(item) {
  if (!item || typeof item === "string") {
    // console.log('item: ', item)
    return item;
  }
  console.log("item __  type: ", item.__type);
  return item.__type;
}

function defineAbilitiesFor(user) {
  const {
    ADMIN,
    PLANIFICADOR,
    PLANIFICADOR_VACIOS,
    SOLICITANTE,
    EJECUTIVO_COMERCIAL,
    PLANIFICADOR_PORTEO,
    SUPERVISOR_VACIOS,
    SUPERVISOR_MOVIMIENTOS_INTERNOS,
    MECANICO,
    PLANIFICADOR_MANTENIMIENTO,
    ADMINISTRATIVO,
    ABASTECEDOR,
    PROVEEDOR,
    CCTV,
    EJECUTIVO_CUENTA
  } = constants;
  return AbilityBuilder.define({ subjectName }, (can, cannot) => {
    if (user && user.role) {
      switch (user.role.code) {
        case ADMIN:
          can(["manage"], "Dashboard");
          can(["manage"], "Company");
          can(["manage"], "Trucks");
          can(["manage"], "Carts");
          can(["view"], "Fuels");
          can(["manage"], "User");
          can(["manage"], "Providers");
          can(["manage"], "Account");
          can(["manage"], "Payment");
          can(["manage"], "Requeriments");
          can(["manage"], "Zones");
          can(["manage"], "Sinisters");
          can(["manage"], "Liquidación");
          break;
        case PLANIFICADOR_PORTEO:
        case PLANIFICADOR:
          can(["manage"], "Dashboard");
          can(["manage"], "Trucks");
          can(["view"], "Fuels");
          can(["manage"], "Requeriments");
          can(["read", "view", "backState", "endRequeriment"], "Requeriments");
          can(["edit"], "service");
          can(["view"], "Map");
          can(["manage"], "Account");
          can(["manage", "view"], "Voids");
          cannot("add", "Voids");
          can(["assign", "unassign", "approve"], "Voids");
          break;
        case PLANIFICADOR_VACIOS:
          can(["manage"], "Dashboard");
          can(["view", "read"], "Requeriments");
          can(["edit"], "service");
          can(["view"], "Map");
          can(["manage"], "Account");
          can(["manage", "view"], "Voids");
          cannot("add", "Voids");
          can(["assign", "unassign", "approve"], "Voids");
          break;
        case EJECUTIVO_COMERCIAL:
          can(["manage"], "Dashboard");
          can(["view", "read"], "Requeriments");
          can(["read"], "Companies");
          can(["edit"], "service");
          can(["manage"], "Account");
          can(["view"], "Voids");
          break;
        case EJECUTIVO_CUENTA:
          can(["manage"], "Dashboard");
          can(["read", "view", "create"], "Requeriments");
          can(["edit"], "service");
          can(["view"], "Map");
          can(["view", "add"], "Voids");
          can(["manage"], "Account");
          break;
        case SUPERVISOR_VACIOS:
          can(["manage"], "Dashboard");
          can(["manage", "add", "view"], "Voids");
          cannot(["assign", "unassign", "approve"], "Voids");
          can(["manage"], "Account");
          break;
        case SOLICITANTE:
          can(["manage"], "Dashboard");
          can(["create"], "Requeriments");
          can(["read", "view"], "Requeriments");
          can(["edit"], "service", { company_id: user.company_id });
          can(["view"], "Map");
          can(["view", "manage", "add"], "Voids");
          can(["manage"], "Account");
          break;
        case SUPERVISOR_MOVIMIENTOS_INTERNOS:
          can(["manage"], "Dashboard");
          can(["manage"], "Movements");
          can(["manage"], "Account");
          break;
        case MECANICO:
          can(["manage"], "Dashboard");
          can(["manage"], "Incidents");
          can(["manage"], "Maintenance");
          can(["manage"], "Account");
          break;
        case PLANIFICADOR_MANTENIMIENTO:
          can(["manage"], "Dashboard");
          can(["manage"], "Maintenance");
          can(["manage"], "Account");
          break;
        case ADMINISTRATIVO:
          can(["manage"], "Dashboard");
          can(["manage"], "Expirated");
          can(["manage"], "Account");
          can(["manage"], "Payment");
          can(["manage"], "Rates");
          can(["manage"], "Zones");
          break;
        case ABASTECEDOR:
          can(["manage"], "Dashboard");
          can(["view", "add"], "Fuels");
          break;
        case PROVEEDOR:
          can(["manage"], "Dashboard");
          can(["manage"], "Trucks");
          can(["manage"], "Payment");
          can(["manage"], "Liquidación");
          break;
        case CCTV:
          can(["manage"], "Dashboard");
          can(["view", "read"], "Requeriments");
          can(["view"], "Voids");
          can(["view"], "Map");
          can(["manage"], "Account");
          break;
      }
    }
  });
}

export default defineAbilitiesFor;
